import { message, PageHeader, Popconfirm, Tag, Tooltip } from "antd";
import axios from "axios";
import React, { Component } from "react";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";
import { ButtonItem, SegmentedItem, TableItemDinamico, dineroDisabledMask, NotificacionMovimientosInventario, pedidoVigenciaVencida } from "../../../Components/Items";
import { EditOutlined, CloseCircleOutlined,ShoppingCartOutlined, ShoppingOutlined, LockOutlined, UnlockOutlined, CheckCircleOutlined, DownloadOutlined } from "@ant-design/icons";
//import EstadosLeyenda from "../../../Components/EstadosLeyenda";
import GenerarVentaDePedido from "./GenerarVentaDePedido/GenerarVentaDePedido";
import ModalDescargarDocumentos from "../../../Components/ModalDescargarDocumentos";
import descargarDocumentosMasivo, { MODULOS } from "../../../Components/DescargarDocumentosMasivo";

moment.locale("es");

class Pedidos extends Component {
    tableRef = null;
    state = {
        todasPedidos: [],
        loading: false,
        modalCancelacion: false,
        modalCancelacionId: null,
        modalEnvios: false,
        modalEnviosId: null,
        modalGenerarVenta: false,
        modalGenerarVentaId: null,
        valor: 1,
        textoFiltro: "",
        totalRecords: 0,
        pedidosSeleccionados: [],
        objetoPedidosEncontrados: [],
        modalDescarga: { visible: false, loading: false, progreso: { hechos: 0, total: 0 } },
    };

    consultarPedidos(params) {
        this.setState({ loading: true });
        axios
            .post(
                "pedidos/selectPedidos",
                { empresaId: this.props.empresaId, ...params },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    const pedidos = res.data.data.map((value) => {
                        let numero = value.pedidoSerie + ' ' + value.pedidoNumero;
                        return {
                            ...value,
                            fechaPedido: value.fechaPedido,
                            numero: numero,
                            cliente: (value.cliente.persona
                                ? value.cliente.razonSocial
                                : (value.cliente.nombre + ' ' + value.cliente.apellidoPaterno + ' ' + value.cliente.apellidoMaterno)
                            ) + " - " + value.cliente.rfc,
                            clienteNombre: (value.cliente.persona
                                ? value.cliente.razonSocial
                                : (value.cliente.nombre + ' ' + value.cliente.apellidoPaterno + ' ' + value.cliente.apellidoMaterno)),
                            clienteClave: value.cliente.clave || '',
                            clienteNombreComercial: value.cliente.nombreComercial || '',
                            clienteRfc: value.cliente.rfc,
                            vendedor: value.vendedor ? (value.vendedor.nombre + " " + (value.vendedor.apellidoPaterno || "") + ' ' + (value.vendedor.apellidoMaterno || "")) : '',
                            requerido: value.requerido,
                            requisicionNumero: value.requisicion
                                ? ((value.requisicion.serie ? value.requisicion.serie + ' ' : '') + value.requisicion.numero)
                                : null,
                            accion: {
                                _id: value._id,
                                estado: value.estado,
                                servicios: value.servicios,
                                createdAt: value.createdAt,
                                cerrado: value.cerrado,
                                finiquitado: value.finiquitado,
                            },
                        };
                    });
                    this.setState({
                        todasPedidos: pedidos,
                        totalRecords: res.data.totalRecords || 0,
                    });
                } else {
                    this.setState({ todasPedidos: [], totalRecords: 0 });
                }
            })
            .catch((error) => {
                console.error('Error al consultar pedidos:', error);
                this.setState({ loading: false });
            });
    }

    agregarPedido() {
        this.props.history.push("/panel/agregarPedido");
    }

    importarPedidosIMSS() {
        this.props.history.push("/panel/importarPedidosIMSS");
    }

    // agregarPedidoConLotes() {
    //     this.props.history.push("/panel/agregarPedidoConLotes");
    // }

    cerrarGenerarVentaDePedido() {
        this.setState({
            modalGenerarVenta: false,
            modalGenerarVentaId: null,
        });
        if (this.tableRef) {
            this.tableRef.updateExternalFilters({ valor: this.state.valor });
        }
    }

    cancelarPedido(value) {
        axios
            .post(
                "pedidos/cancelarPedido",
                { pedidoId: value, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    message.success("Pedido cancelado");
                    NotificacionMovimientosInventario(res.data.movimientosIds);
                } else if (res.data.success === 1) {
                    message.warn(res.data.message);
                } else {
                    message.error("Sucedio un error y no se pudo cancelar");
                }
                if (this.tableRef) {
                    this.tableRef.updateExternalFilters({ valor: this.state.valor });
                }
            });
    }

    cerrarPedido(value) {
        axios
            .post(
                "pedidos/cerrarPedido",
                { pedidoId: value, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    message.success("Pedido cerrado");
                } else if (res.data.success === 1) {
                    message.warn(res.data.message);
                } else {
                    message.error("Sucedio un error y no se pudo cerrar");
                }
                if (this.tableRef) {
                    this.tableRef.updateExternalFilters({ valor: this.state.valor });
                }
            });
    }

    abrirPedido(value) {
        axios
            .post(
                "pedidos/abrirPedido",
                { pedidoId: value, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    message.success("Pedido abierto");
                } else if (res.data.success === 1) {
                    message.warn(res.data.message);
                } else {
                    message.error("Sucedio un error y no se pudo abrir");
                }
                if (this.tableRef) {
                    this.tableRef.updateExternalFilters({ valor: this.state.valor });
                }
            });
    }

    finiquitarPedido(value) {
        axios
            .post(
                "pedidos/finiquitarPedido",
                { pedidoId: value, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    message.success("Pedido finiquitado");
                } else if (res.data.success === 1) {
                    message.warn(res.data.message);
                } else {
                    message.error("Sucedio un error y no se pudo finiquitar");
                }
                if (this.tableRef) {
                    this.tableRef.updateExternalFilters({ valor: this.state.valor });
                }
            });
    }

    editarPedido(id) {
        this.props.history.push("/panel/editarPedido", { id });
    }

    // Con el complemento PSW, un pedido cuya orden de compra del cliente ya
    // vencio no se puede consumir: ni generar embarque/venta, ni cerrar, ni
    // finiquitar, ni seleccionar. Solo ver, cancelar y editar (editar queda
    // abierto para poder renovar la fecha de vigencia).
    vigenciaVencida = (pedido) => {
        return pedidoVigenciaVencida(pedido, this.props.complementoPSWPedidos);
    }

    generarVentaDePedido(id) {
        this.setState({
            modalGenerarVenta: true,
            modalGenerarVentaId: id,
        });
    }

    generarEmbarqueDePedido(id) {
        this.props.history.push("/panel/agregarEmbarque", { pedidosSeleccionados: [id] });
    }

    // La seleccion es libre: cualquier pedido se puede marcar, porque tambien
    // alimenta la descarga masiva. La vigencia de la orden de compra, el estado
    // y el mismo cliente se validan al usar Generar Embarque/Venta.
    onSelectChange = (pedidosSeleccionados) => {

        let encontrarPedidos = [];

        for (const pedidoId of pedidosSeleccionados) {
            const yaGuardado = this.state.objetoPedidosEncontrados.find(c => c._id?.toString() === pedidoId);
            if (yaGuardado) continue;
            const pedido = this.state.todasPedidos.find(c => c._id?.toString() === pedidoId);
            if (pedido) encontrarPedidos.push(pedido);
        }

        this.setState({ pedidosSeleccionados, objetoPedidosEncontrados: [...this.state.objetoPedidosEncontrados, ...encontrarPedidos] });
    }

    generarEmbarquePedidos() {
        const { pedidosSeleccionados } = this.state;
        if (pedidosSeleccionados.length === 0) {
            message.warn("No hay pedidos seleccionados");
            return;
        }

        let clienteId = "";

        for (const pedidoId of this.state.pedidosSeleccionados) {
            let pedido = this.state.objetoPedidosEncontrados.find(c => c._id?.toString() === pedidoId);
            if (pedido) {
                // Revalidar: la seleccion pudo hacerse antes de que cruzara la medianoche
                if (this.vigenciaVencida(pedido)) {
                    message.warn(`El pedido ${pedido.numero || ""} tiene la orden de compra vencida`);
                    return;
                }
                if (pedido.estado !== 1 && pedido.estado !== 2) {
                    message.warn(`El pedido ${pedido.numero || ""} no esta vigente ni pendiente`);
                    return;
                }
                if (clienteId) {
                    if (clienteId !== pedido.clienteId?.toString()) {
                        message.warn("Los pedidos seleccionados no pertenecen al mismo cliente");
                        return;
                    }
                } else {
                    clienteId = pedido.clienteId?.toString();
                }
            } else {
                message.warn("No se encontró el pedido seleccionado");
                return;
            }
        }

        const destino = this.props.embarques ? "/panel/agregarEmbarque" : "/panel/agregarVenta";
        this.props.history.push(destino, { pedidosSeleccionados });
    }

    generarRequisicionPedidos() {
        const { pedidosSeleccionados } = this.state;
        if (pedidosSeleccionados.length === 0) {
            message.warn("No hay pedidos seleccionados");
            return;
        }

        for (const pedidoId of pedidosSeleccionados) {
            const pedido = this.state.objetoPedidosEncontrados.find(c => c._id?.toString() === pedidoId);
            if (pedido && this.vigenciaVencida(pedido)) {
                message.warn(`El pedido ${pedido.numero || ""} tiene la orden de compra vencida`);
                return;
            }
        }

        this.props.history.push('/panel/requerirInsumosPedido', { pedidosIds: pedidosSeleccionados });
    }

    abrirDescarga() {
        this.setState({ modalDescarga: { visible: true, loading: false, progreso: { hechos: 0, total: 0 } } });
    }

    cerrarDescarga() {
        this.setState({ modalDescarga: { visible: false, loading: false, progreso: { hechos: 0, total: 0 } } });
    }

    async confirmarDescarga(formatos) {
        this.setState((prev) => ({ modalDescarga: { ...prev.modalDescarga, loading: true } }));
        await descargarDocumentosMasivo({
            modulo: "pedido",
            ids: this.state.pedidosSeleccionados,
            empresaId: this.props.empresaId,
            headersToken: this.props.headersToken,
            ...formatos,
            onProgreso: (hechos, total) => this.setState((prev) => ({
                modalDescarga: { ...prev.modalDescarga, progreso: { hechos, total } },
            })),
        });
        this.cerrarDescarga();
    }

    render() {
        const columns = [
            {
                title: "Num / OC",
                dataIndex: "numero",
                key: "numero",
                buscar: 'numero',
                render: (_, record) => (
                    <div>
                        <div style={{ fontSize: "12px", fontWeight: 500 }}>
                            {record.numero}
                        </div>
                        {record.ordenDeCompra && (
                            <div style={{ fontSize: "12px", color: "#666" }}>
                                OC: {record.ordenDeCompra}
                            </div>
                        )}
                    </div>
                ),
                width: 200,
                ellipsis: true,
            },
            {
                title: "OC",
                dataIndex: "ordenDeCompra",
                key: "ordenDeCompra",
                buscar: 'ordenDeCompra',
                responsive: [],
                width: 0,
            },
            {
                title: "Proyecto",
                dataIndex: "proyecto",
                responsive: ['md'],
                key: "proyecto",
                sorter: true,
                render: (value) => <span style={{ fontSize: "11px" }}>{value.nombre}</span>,
                width: "9%",
                ellipsis: true,
            },
             {
                title: "Cliente / Vendedor",
                dataIndex: "clienteNombre",
                key: "clienteNombre",
                buscar: "cliente",
                render: (_, record) => (
                    <div style={{ display: "flex", flexDirection: "column" }}>
                    <span style={{ fontSize: "12px", fontWeight: "bold" }}>
                        {record.clienteClave ? `${record.clienteClave} - ${record.clienteNombre}` : record.clienteNombre}
                    </span>
                    {/* {record.clienteNombreComercial && (
                        <span style={{ fontSize: "10px", color: "#999", fontStyle: "italic" }}>↳ {record.clienteNombreComercial}</span>
                    )} */}
                    <span style={{ fontSize: "12px", color: "#666" }}>{record.vendedor || "-"}</span>
                    </div>
                ),
                width: window.innerWidth >= 1800 ? "21%" : "23%",
                ellipsis: true,
            },
            {
                title: "RFC",
                dataIndex: "clienteRfc",
                key: "clienteRfc",
                render: (value) => (
                    <div style={{ fontSize: "12px" }}>
                        {value}
                    </div>
                ),
                width: "8%",
                ellipsis: true,
                
            },
            {
                title: "Fecha",
                dataIndex: "fechaPedido",
                responsive: ['md'],
                key: "fechaPedido",
                sorter: true,
                render: (value) => moment(value).locale('es').format("DD/MM/YY HH:mm"),
                width: window.innerWidth > 2000 ? 100 : 120,
                ellipsis: true,
                align: "center",
            },
            ...(this.props.complementoPSWPedidos ? [{
                title: "Vigencia",
                dataIndex: "fechaVigencia",
                responsive: ['md'],
                key: "fechaVigencia",
                sorter: true,
                render: (value) => value ? moment(value).locale('es').format("DD/MM/YY") : "",
                width: window.innerWidth > 2000 ? 90 : 110,
                ellipsis: true,
                align: "center",
            }] : []),
            {
                title: "Subtotal / Total",
                dataIndex: "subtotal",
                key: "subtotal",
                responsive: ["md"],
                sorter: true,
                buscar: "subtotal",
                render: (_, record) => (
                    <div style={{ textAlign: "right" }}>
                        <div style={{ fontSize: "12px", color: "#666" }}>
                            {dineroDisabledMask(record.subtotal)} {record.moneda}
                        </div>
                        <div style={{ fontWeight: "bold", fontSize: "12px" }}>
                            {dineroDisabledMask(record.total)} {record.moneda}
                        </div>
                    </div>
                ),
                width: 150,
                ellipsis: true,
                align: "right",
            },
            {
                title: "Total",
                dataIndex: "total",
                key: "total",
                sorter: true,
                buscar: "total",
                responsive: [],
                width: 0,
            },
            {
                title: "Estado",
                dataIndex: "estado",
                responsive: ['md'],
                key: "estado",
                render: (value, record) => {
                    let tag;
                    if (value === 0) {
                        tag = <Tag color="red"  className="square-tag">Cancelada</Tag>;
                    } else if (value === 1) {
                        tag = <Tag color="blue"  className="square-tag">Vigente</Tag>;
                    } else if (value === 2) {
                        tag = <Tag color="blue"  className="square-tag">Pendiente</Tag>;
                    } else if (value === 3) {
                        tag = <Tag color="green"  className="square-tag">Venta</Tag>;
                    }
                    return (
                        <div style={{ display: "flex", flexDirection: "column", gap: "4px", alignItems: "flex-start" }}>
                            <div style={{ display: "flex", gap: "4px", alignItems: "center" }}>
                                {tag}
                            </div>
                            {record.finiquitado && (
                                <div style={{ display: "flex", gap: "4px", alignItems: "center" }}>
                                    <Tag color="purple" className="square-tag">Finiquitado</Tag>
                                </div>
                            )}
                            {!record.finiquitado && record.cerrado && (
                                <div style={{ display: "flex", gap: "4px", alignItems: "center" }}>
                                    <Tag color="gold" className="square-tag">Cerrado</Tag>
                                </div>
                            )}
                            {(record.estadoEntrega === 2 || record.estadoEntrega === 3) && (
                                <div style={{ display: "flex", gap: "4px", alignItems: "center" }}>
                                    {record.estadoEntrega === 2 && <Tag color="orange" className="square-tag">Entrega par.</Tag>}
                                    {record.estadoEntrega === 3 && <Tag color="green" className="square-tag">Entregado</Tag>}
                                </div>
                            )}
                            {record.requerido && (
                                <div style={{ display: "flex", gap: "4px", alignItems: "center" }}>
                                    <Tag color="geekblue" className="square-tag">
                                        Requerido{record.requisicionNumero ? ": " + record.requisicionNumero : ""}
                                    </Tag>
                                </div>
                            )}
                        </div>
                    );
                },
                width: 120,
                ellipsis: true,
            },
            {
                title: "Acción",
                dataIndex: "accion",
                key: "accion",
                fixed: window.innerWidth > 1200 ? "right" : null,
                width: "12%",
                align: "center",
                onCell: () => ({
                    className: "acciones-sin-hover"
                }),
                render: (value) => {
                    if (value.estado === 0) return null;

                    let buttons = [];

                    const vigenciaVencida = this.vigenciaVencida(value);
                    const motivoVigencia = "La orden de compra del cliente está vencida";
                    const entregaParcial = !this.props.embarques && value.estadoEntrega === 2;
                    const motivoEntregaParcial = "Este pedido tiene entrega parcial de insumos, no se puede convertir en venta";

                    const puedeGenerarVenta = (value.estado === 1) && this.props.permisoGenerarVentasPedidos && !vigenciaVencida && !entregaParcial;
                    const tooltipGenerar = this.props.embarques ? "Generar Embarque" : "Generar Venta";
                    buttons.push(
                        <Tooltip title={puedeGenerarVenta ? tooltipGenerar : vigenciaVencida ? motivoVigencia : entregaParcial ? motivoEntregaParcial : "No disponible"} placement="top">
                            <span>
                                <ButtonItem
                                    type="default"
                                    size="small"
                                    lima
                                    icon={<ShoppingCartOutlined />}
                                    onClick={() => this.props.embarques ? this.generarEmbarqueDePedido(value._id) : this.generarVentaDePedido(value._id)}
                                    disabled={!puedeGenerarVenta}
                                >
                                </ButtonItem>
                            </span>
                        </Tooltip>
                    );
                    const puedeEntregar = (value.estado === 1 || value.estado === 2) && this.props.entregarInsumosPedidosComplemento;
                    buttons.push(
                        <Tooltip title={puedeEntregar ? "Entregar Insumos" : "No disponible"} placement="top">
                            <ButtonItem
                                type="default"
                                size="small"
                                naranja
                                icon={<ShoppingOutlined />}
                                onClick={() => puedeEntregar && this.props.history.push('/panel/entregarInsumosPedido', { pedidoId: value._id })}
                                disabled={!puedeEntregar}
                            >
                            </ButtonItem>
                        </Tooltip>
                    );
                    const puedeEditar = (value.estado === 1 || value.estado === 2) && this.props.permisoEditarPedidos && !value.cerrado && !value.finiquitado;
                    buttons.push(
                        <Tooltip title={puedeEditar ? "Editar" : (value.cerrado || value.finiquitado) ? "El pedido está cerrado o finiquitado" : "No disponible para edición"} placement="top">
                            <ButtonItem
                                type="default"
                                size="small"
                                cyan
                                icon={<EditOutlined />}
                                onClick={() => puedeEditar && this.editarPedido(value._id)}
                                disabled={!puedeEditar}
                            >
                            </ButtonItem>
                        </Tooltip>
                    );

                    const puedeCancelar = value.estado !== 0 && value.estado !== 3 && !value.cerrado && this.props.permisoCancelarPedidos;
                    buttons.push(
                        <Popconfirm
                            title="Seguro que quiere cancelar este pedido"
                            onConfirm={() => this.cancelarPedido(value._id)}
                            okText="Ok"
                            cancelText="Cancelar"
                            disabled={!puedeCancelar}
                        >
                            <Tooltip title={puedeCancelar ? "Cancelar" : "No se puede cancelar"} placement="top">
                                <ButtonItem
                                    type="default"
                                    size="small"
                                    rojo
                                    icon={<CloseCircleOutlined />}
                                    disabled={!puedeCancelar}
                                >
                                </ButtonItem>
                            </Tooltip>
                        </Popconfirm>
                    );

                    if (this.props.cerrarPedidosComplemento && !value.finiquitado) {
                        if (value.cerrado) {
                            const puedeAbrir = this.props.permisoAbrirPedidos;
                            buttons.push(
                                <Popconfirm
                                    title="Seguro que quiere abrir este pedido"
                                    onConfirm={() => this.abrirPedido(value._id)}
                                    okText="Ok"
                                    cancelText="Cancelar"
                                    disabled={!puedeAbrir}
                                >
                                    <Tooltip title={puedeAbrir ? "Abrir" : "No se puede abrir"} placement="top">
                                        <ButtonItem
                                            type="default"
                                            size="small"
                                            icon={<UnlockOutlined />}
                                            disabled={!puedeAbrir}
                                        >
                                        </ButtonItem>
                                    </Tooltip>
                                </Popconfirm>
                            );
                        } else {
                            const puedeCerrar = (value.estado === 1 || value.estado === 2) && this.props.permisoCerrarPedidos && !vigenciaVencida;
                            buttons.push(
                                <Popconfirm
                                    title="Seguro que quiere cerrar este pedido"
                                    onConfirm={() => this.cerrarPedido(value._id)}
                                    okText="Ok"
                                    cancelText="Cancelar"
                                    disabled={!puedeCerrar}
                                >
                                    <Tooltip title={puedeCerrar ? "Cerrar" : vigenciaVencida ? motivoVigencia : "No se puede cerrar"} placement="top">
                                        <ButtonItem
                                            type="default"
                                            size="small"
                                            icon={<LockOutlined />}
                                            disabled={!puedeCerrar}
                                        >
                                        </ButtonItem>
                                    </Tooltip>
                                </Popconfirm>
                            );
                        }
                    }

                    if (this.props.finiquitarPedidosComplemento) {
                        const puedeFiniquitar = value.estado === 2 && !value.finiquitado && this.props.permisoFiniquitarPedidos && !vigenciaVencida;
                        buttons.push(
                            <Popconfirm
                                title="Seguro que quiere finiquitar este pedido"
                                onConfirm={() => this.finiquitarPedido(value._id)}
                                okText="Ok"
                                cancelText="Cancelar"
                                disabled={!puedeFiniquitar}
                            >
                                <Tooltip title={puedeFiniquitar ? "Finiquitar" : vigenciaVencida ? motivoVigencia : "No se puede finiquitar"} placement="top">
                                    <ButtonItem
                                        type="default"
                                        size="small"
                                        morado
                                        icon={<CheckCircleOutlined />}
                                        disabled={!puedeFiniquitar}
                                    >
                                    </ButtonItem>
                                </Tooltip>
                            </Popconfirm>
                        );
                    }

                    return <div className="acciones-container">{buttons}</div>;
                },
            },
        ];

        return (
            <>
                <PageHeader
                    title="Pedidos"
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                    extra={
                        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                            {window.innerWidth > 1000 &&
                                <SegmentedItem
                                    options={[
                                        { label: 'Vigente', value: 1 },
                                        { label: 'Pendiente', value: 2 },
                                        { label: 'Terminado', value: 3 },
                                        { label: 'Cancelada', value: 4 },
                                        { label: 'Todos', value: 5 }
                                    ]}
                                    onChange={(value) => {
                                        if (this.tableRef) {
                                            this.tableRef.updateExternalFilters({ valor: value, textoFiltro: this.state.textoFiltro });
                                        }
                                        this.setState({ valor: value });
                                    }}
                                    value={this.state.valor}
                                />
                            }
                            {this.props.permisoAgregarPedidos &&
                                <ButtonItem
                                    type="primary"
                                    key="agregarPedido"
                                    olivo
                                    onClick={this.agregarPedido.bind(this)}
                                    className="botonAgregar"
                                >
                                    Agregar Pedido
                                </ButtonItem>}
                            {(this.props.permisoAgregarPedidos && this.props.importarPedidosIMSS) &&
                                <ButtonItem
                                    type="primary"
                                    key="importarPedidosIMSS"
                                    cyan
                                    onClick={this.importarPedidosIMSS.bind(this)}
                                    className="botonAgregar"
                                >
                                    Importar Pedidos IMSS
                                </ButtonItem>}
                            {/* {this.props.permisoAgregarCotizaciones &&
                                <ButtonItem
                                    type="primary"
                                    key="agregarPedidoConLotes"
                                    onClick={this.agregarPedidoConLotes.bind(this)}
                                    style={{ fontSize: '14px', padding: '6.4px 15px', height: '32px' }}
                                >
                                    Agregar Base Cotizacion
                                </ButtonItem>} */}

                            {(this.props.permisoVerPedidos && this.state.pedidosSeleccionados.length > 0) &&
                                <ButtonItem
                                    blanco
                                    icon={<DownloadOutlined />}
                                    key="descargarPedidos"
                                    onClick={this.abrirDescarga.bind(this)}
                                    style={{ fontSize: '14px', padding: '6.4px 15px', height: '32px' }}
                                >
                                    Descargar ({this.state.pedidosSeleccionados.length})
                                </ButtonItem>}
                            {(this.props.permisoGenerarVentasPedidos && this.state.pedidosSeleccionados.length > 0) &&
                                <ButtonItem
                                    type="primary"
                                    cyan
                                    key="generarEmbarquePedidos"
                                    onClick={this.generarEmbarquePedidos.bind(this)}
                                    style={{ fontSize: '14px', padding: '6.4px 15px', height: '32px' }}
                                >
                                    {this.props.embarques ? "Generar Embarque" : "Generar Venta"}
                                </ButtonItem>}
                            {this.state.pedidosSeleccionados.length > 0 && this.props.generarRequisicionPedidosComplemento &&
                                <ButtonItem
                                    type="primary"
                                    olivo
                                    key="generarRequisicionPedidos"
                                    onClick={this.generarRequisicionPedidos.bind(this)}
                                    style={{ fontSize: '14px', padding: '6.4px 15px', height: '32px' }}
                                >
                                    Generar Requisición
                                </ButtonItem>}
                        </div>
                    }
                />

                <TableItemDinamico
                    ref={(ref) => this.tableRef = ref}
                    onRef={(ref) => this.tableRef = ref}
                    totalRecords={this.state.totalRecords}
                    onlyMineFilter
                    estadosLeyenda={[
                        { color: 'rgba(166, 255, 144, 0.6)', label: 'Apartado', key: 'apartado' },
                        { color: 'rgba(255, 174, 82, 0.6)', label: 'Material recibido', key: 'material-recibido' },
                    ]}
                    semaforoVigencia={this.props.complementoPSWPedidos}
                    onRow={(record, rowIndex) => {
                        return {
                            onDoubleClick: (event) => {
                                if (this.props.permisoVerPedidos) {
                                    this.props.history.push("/panel/verPedido", { id: record._id });
                                }
                            },
                        };
                    }}
                    anadirValorFiltro={this.state.valor}
                    onFetchData={this.consultarPedidos.bind(this)}
                    loading={this.state.loading}
                    size="small"
                    scroll={{ x: "max-content" }} // o un número, p.ej. { x: 1400 }
                    dataSource={this.state.todasPedidos}
                    columns={columns}
                    filterStorageKey={"pedidosFiltradosTabla" + this.props.empresaId}
                    pagination={false}
                    setValor={(valor) => this.setState({ valor })}
                    valorDefault={1}
                    setTextoFiltro={(textoFiltro) => this.setState({ textoFiltro })}
                    valorTextoDefault={""}
                    rowSelection={{
                        selectedRowKeys: this.state.pedidosSeleccionados,
                        onChange: this.onSelectChange.bind(this),
                        // Con la orden de compra vencida el pedido igual se puede
                        // seleccionar para descargarlo; el bloqueo real está en
                        // Generar Embarque/Venta y en Generar Requisición.
                        getCheckboxProps: (record) => ({
                            title: this.vigenciaVencida(record)
                                ? "La orden de compra del cliente está vencida"
                                : undefined,
                        }),
                        // La tabla pagina del lado del servidor: sin esto, antd
                        // tira las llaves de las páginas anteriores al paginar.
                        preserveSelectedRowKeys: true,
                    }}
                />

                <GenerarVentaDePedido
                    visible={this.state.modalGenerarVenta}
                    id={this.state.modalGenerarVentaId}
                    cerrarGenerarVentaDePedido={this.cerrarGenerarVentaDePedido.bind(this)}
                />

                <ModalDescargarDocumentos
                    visible={this.state.modalDescarga.visible}
                    loading={this.state.modalDescarga.loading}
                    progreso={this.state.modalDescarga.progreso}
                    total={this.state.pedidosSeleccionados.length}
                    tieneXml={MODULOS.pedido.tieneXml}
                    onClose={this.cerrarDescarga.bind(this)}
                    onConfirm={this.confirmarDescarga.bind(this)}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
        taxidermia: state.empresa.taxidermia,
        embarques: state.empresa.embarques,
        complementoPSWPedidos: state.empresa.complementoPSWPedidos,
        importarPedidosIMSS: state.empresa.importarPedidosIMSS,
        permisoAgregarVenta:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                    valueTodos.permisoId.toString() === "615ccb6bf30e81b54183cf70"
            )?.activado,
        permisoAgregarCotizaciones:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                    valueTodos.permisoId.toString() === "6750922d798d4e0043687242"
            )?.activado,
        permisoCancelarCotizaciones:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                    valueTodos.permisoId.toString() === "6750922d798d4e0043687242"
            )?.activado,
        permisoVerCotizaciones:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                    valueTodos.permisoId.toString() === "6750925b798d4e0043687244"
            )?.activado,
        permisoAgregarPedidos:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                valueTodos.permisoId.toString() === "689fd5677ec315a681480e9a"
            )?.activado,
        permisoVerPedidos:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                valueTodos.permisoId.toString() === "69025dbc665a8b9d4efb4eb1"
            )?.activado,
        permisoCancelarPedidos:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                valueTodos.permisoId.toString() === "689fd5817ec315a681480e9b"
            )?.activado,
        permisoGenerarVentasPedidos:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                valueTodos.permisoId.toString() === "689fd5bb7ec315a681480e9c"
            )?.activado,
        // Gateado por complemento de empresa, no por permiso.
        entregarInsumosPedidosComplemento: state.empresa.entregarInsumosPedidos,
        generarRequisicionPedidosComplemento: state.empresa.generarRequisicionPedidos,
        permisoEditarPedidos:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                valueTodos.permisoId.toString() === "69025d9e665a8b9d4efb4eb0"
            )?.activado,
        permisoCerrarPedidos:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                valueTodos.permisoId.toString() === "6a49627f84f0696e60ab8f94"
            )?.activado,
        permisoAbrirPedidos:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                valueTodos.permisoId.toString() === "6a49628b84f0696e60ab909f"
            )?.activado,
        permisoFiniquitarPedidos:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                valueTodos.permisoId.toString() === "6a49629984f0696e60ab90be"
            )?.activado,
        cerrarPedidosComplemento: state.empresa.cerrarPedidos,
        finiquitarPedidosComplemento: state.empresa.finiquitarPedidos,
    };
};

export default connect(mapStateToProps)(Pedidos);